/* Business events contain only public destinations and explicitly allowed form metadata. */
(() => {
  if (/\/(?:account|customer_authentication|checkouts?|orders|gift_cards)(?:\/|$)/.test(location.pathname) || /\/pages\/library\/?$/.test(location.pathname)) return;
  const capture = (name, properties = {}) => {
    try { return window.SaunaAnalytics?.capture(name, properties) === true; } catch (_) { return false; }
  };
  const placement = element => {
    for (const [selector, name] of [
      ['.sa-premium-header', 'header'], ['.footer', 'footer'], ['.hero-actions', 'hero'],
      ['.offer-card', 'offer'], ['.mobile-buy', 'mobile_bar'], ['[data-project-guide]', 'project_guide'],
      ['[data-project-breakdown]', 'materials_breakdown'], ['[data-project-calculator]', 'project_calculator'],
      ['[data-heater-calculator]', 'heater_calculator'], ['#faq', 'faq'], ['#experience', 'experience'],
      ['.provenance', 'provenance']
    ]) if (element.closest(selector)) return name;
    return 'content';
  };
  const safePath = url => /^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?(?:$|pages\/(?:heater-calculator|sauna-cost-calculator|sauna-faq|contact)\/?$|products\/[a-z0-9-]+\/?$|collections(?:\/[a-z0-9-]+)?\/?$|policies\/[a-z0-9-]+\/?$|blogs\/[a-z0-9/-]+\/?$|search\/?$)/.test(url.pathname) ? url.pathname : undefined;
  const partnerHosts = ['saunainter.com', 'saunademo.com', 'spaprof.com', 'saunamaailm.ee', 'intercomgroup.ee'];
  const knownAnchor = hash => ['#offer', '#inside', '#included', '#experience', '#preview-heater-sheet', '#project-quote', '#planning-layout', '#heaters', '#ventilation-drying', '#walls-materials', '#buying-the-blueprint'].includes(hash) ? hash.slice(1) : undefined;

  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link || link.closest('.sa-library')) return;
    let url;
    try { url = new URL(link.href, location.href); } catch (_) { return; }
    const source = placement(link);
    if (url.protocol === 'mailto:') { capture('support_clicked', { placement: source, channel: 'email' }); return; }
    if (!['http:', 'https:'].includes(url.protocol)) return;
    const host = url.hostname.replace(/^www\./, '');
    if (partnerHosts.includes(host)) {
      capture('outbound_partner_clicked', { placement: source, destination_host: host, destination_path: url.pathname });
      if (link.closest('[data-calc-output]')) capture('heater_supplier_clicked', { destination_host: host, destination_path: url.pathname });
      return;
    }
    if (url.origin !== location.origin) return;
    if (link.matches('.sa-cart-line a.small') && /\/cart\/change\/?$/.test(url.pathname)) {
      capture('cart_remove_clicked', { placement: 'cart' });
      return;
    }
    const checkout = url.pathname.match(/\/cart\/(\d+):(\d+)\/?$/);
    if (checkout) {
      capture('checkout_clicked', { placement: source, variant_id: checkout[1], quantity: Number(checkout[2]), checkout_entry: 'cart_permalink' });
      return;
    }
    const destination_path = safePath(url), destination_section = knownAnchor(url.hash);
    const destination = { placement: source, ...(destination_path ? { destination_path } : {}), ...(destination_section ? { destination_section } : {}) };
    if (link.closest('.sa-premium-header, .footer-links') && (destination_path || destination_section)) capture('navigation_clicked', destination);
    if (destination_section === 'offer' || destination_section === 'inside') capture('guide_cta_clicked', destination);
    if (destination_section === 'preview-heater-sheet') capture('worksheet_clicked', destination);
    if (destination_section === 'project-quote') capture('quotation_cta_clicked', destination);
    if (link.closest('[data-project-guide]')) {
      const mode = link.closest('[data-project-guide]').dataset.guideMode;
      capture('calculator_guide_clicked', { ...destination, installation: mode === 'pro' ? 'pro' : 'diy' });
    }
    if (/\/pages\/library\/?$/.test(url.pathname)) capture('library_clicked', { placement: source });
  });

  document.querySelectorAll('.nav-disclosure').forEach((menu, index) => {
    menu.addEventListener('toggle', () => {
      if (menu.open) capture('navigation_opened', { navigation_group: ['blueprint', 'resources', 'network'][index] || 'custom' });
    });
  });
  document.querySelector('.nav-toggle')?.addEventListener('click', event => {
    const toggle = event.currentTarget;
    queueMicrotask(() => { if (toggle.getAttribute('aria-expanded') === 'true') capture('navigation_opened', { navigation_group: 'mobile' }); });
  });
  document.querySelectorAll('.faq-list details').forEach((details, index) => {
    details.addEventListener('toggle', () => { if (details.open) capture('faq_opened', { faq_index: index + 1 }); });
  });
  for (const [selector, name] of [['.contents-details', 'contents_opened'], ['.sample-descriptions', 'sample_summaries_opened']]) {
    document.querySelector(selector)?.addEventListener('toggle', event => { if (event.currentTarget.open) capture(name); });
  }

  const forms = [
    { form: document.getElementById('ProjectQuote'), kind: 'quotation', prefix: 'quotation' },
    { form: document.getElementById('PremiumContactEmail')?.form, kind: 'contact', prefix: 'contact' }
  ];
  forms.forEach(({ form, kind, prefix }) => {
    if (!form) return;
    let started = false, reportedSuccess = false, reportedServerError = false;
    const invalidFields = new Set();
    const safeFields = kind === 'quotation'
      ? { ProjectName: 'name', ProjectEmail: 'email', ProjectLocation: 'location', ProjectTiming: 'timing', ProjectNotes: 'message' }
      : { PremiumContactName: 'name', PremiumContactEmail: 'email', PremiumContactMessage: 'message' };
    const startForm = event => {
      if (!started && safeFields[event.target.id]) started = capture(`${prefix}_started`, { form_kind: kind });
    };
    form.addEventListener('focusin', startForm);
    form.addEventListener('invalid', event => {
      const field = safeFields[event.target.id];
      if (field && !invalidFields.has(field)) {
        if (capture('form_validation_error', { form_kind: kind, field_name: field, validation_type: event.target.validity.valueMissing ? 'required' : 'invalid_format' })) invalidFields.add(field);
      }
    }, true);
    form.addEventListener('input', event => { invalidFields.delete(safeFields[event.target.id]); startForm(event); });
    document.addEventListener('submit', event => {
      // Existing validation listeners run before this form bubbles to document.
      if (event.target !== form || event.defaultPrevented || kind === 'quotation') return;
      capture(`${prefix}_submitted`, { form_kind: kind });
    });
    const reportSuccess = () => {
      if (!reportedSuccess && form.querySelector('[role="status"]')) {
        reportedSuccess = capture(`${prefix}_success`, { form_kind: kind });
      }
      if (!reportedServerError && form.querySelector('[role="alert"]:not([hidden])')) reportedServerError = capture('form_server_error', { form_kind: kind });
    };
    document.addEventListener('sa:analytics-ready', () => { started = false; invalidFields.clear(); reportSuccess(); });
    document.addEventListener('sa:analytics-stopped', () => { started = false; invalidFields.clear(); });
    // Covers the case where the SDK was already ready when this deferred file ran.
    reportSuccess();
  });

  document.addEventListener('submit', event => {
    const button = event.submitter;
    if (event.defaultPrevented || !button || !event.target.matches('form[action]')) return;
    let path;
    try { path = new URL(event.target.action, location.href).pathname; } catch (_) { return; }
    if (!/\/cart\/?$/.test(path)) return;
    if (button.name === 'checkout') capture('checkout_clicked', { placement: 'cart', checkout_entry: 'cart_form' });
    if (button.name === 'update') capture('cart_update_submitted', { placement: 'cart' });
  });
})();
